





import { Component, Vue } from 'vue-property-decorator';
import ConvocationCard from '@/shared/components/convocation-card/convocation-card.component.vue';
import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';

@Component({
  components: {
    ConvocationCard,
    ExpansionPanel,
  },
})
export default class ConvocationPartial extends Vue {
  private convocationsList = [
    {
      id: '56',
      dates: '2018-09-03T10:10:25.926Z',
      hour: '08:30',
      name: 'Ventas sin freno',
      city: 'Alicante',
      trainer: 'Fernando González',
      kpi: [
        {
          icon: 'icon-levelup_icon_menu_sync',
          text: '80',
        },
        {
          icon: 'icon-levelup_icon_menu_sync',
          text: '4500€',
        },
        {
          icon: 'icon-levelup_icon_menu_sync',
          text: '90',
        },
        {
          icon: 'icon-levelup_icon_menu_sync',
          text: '5400€',
        },
      ],
    },
    {
      id: '58',
      dates: '2018-09-10T10:10:25.926Z',
      hour: '08:30',
      name: 'Ventas sin freno',
      city: 'Valencia',
      trainer: 'Fernando González',
    },
    {
      id: '61',
      dates: '2018-09-11T10:10:25.926Z',
      hour: '08:30',
      name: 'Diamante en bruto',
      city: 'Alicante',
      trainer: 'Carmen Argal',
    },
  ];
}
